var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import 'isomorphic-fetch';
class PresignedUrlUpload {
    constructor() {
        this.put = (presignedUrl, fileContents) => __awaiter(this, void 0, void 0, function* () {
            if (this.useMock) {
                return true;
            }
            try {
                const formData = new FormData();
                formData.append('file', fileContents);
                const requestOptions = {
                    method: 'PUT',
                    body: formData,
                };
                const response = yield fetch(presignedUrl, requestOptions);
                if (response && response.ok && response.status === 200) {
                    const jsonResponse = yield response.json();
                    return jsonResponse.data;
                }
                throw new Error();
            }
            catch (error) {
                error.name = 'API Error';
                error.message = 'Failed to put file: ' + error.message;
                window.routeToErrorPage(error);
            }
        });
        this.useMock = window.location.search.includes('MOCK_E2E');
    }
}
const PresignedUrlUploadApi = new PresignedUrlUpload();
export default PresignedUrlUploadApi;
